export const trackEvent = (eventName: string) => {
  try {
    (window as any).fathom.trackEvent(eventName);
  } catch (err) {
    // Do nothing
  }
};
